import { Module } from '@/configuration/module';
import ACTIVITY_MODULE from '@/configuration/modules/ACTIVITY_MODULE';
import DASHBOARD_MODULE from '@/configuration/modules/DASHBOARD_MODULE';
import PROJECT_MANAGEMENT_MODULE from '../modules/projects/PROJECT_MANAGEMENT_MODULE';
import REPORT_MODULE from '../modules/REPORT_MODULE';
import EMPLOYEES_MODULE from './modules/EMPLOYEES_MODULE.js';
import CONFIGURATION_MODULE from '@/configuration/modules/CONFIGURATION_MODULE';
import CONTACT_MODULE from '@/configuration/modules/CONTACT_MODULE';
import HOLIDAY_MODULE from '@/configuration/modules/HOLIDAY_MODULE';
import NOTIFICATION_MODULE from '@/configuration/modules/NOTIFICATION_MODULE';
import OFFICIAL_HOLIDAYS_MODULE from '@/configuration/modules/OFFICIAL_HOLIDAYS_MODULE';
import SEARCH_MODULE from '@/configuration/modules/SEARCH_MODULE';
import WAREHOUSE_MODULE from '@/configuration/modules/WAREHOUSE_MODULE';
import WORKING_TIME_MODULE from '../modules/WORKING_TIME_MODULE';
import { generateModules } from '@/configuration/module-registry-helper';
import INVOICE_MODULE from "../modules/INVOICE_MODULE";
import CURRENT_USER_MODULE from "@/configuration/modules/CURRENT_USER_MODULE";
import PROCESS_SUPPORT_MODULE from "@/configuration/modules/PROCESS_SUPPORT_MODULE";
import ORDERING_MODULE from '@/configuration/modules/ORDERING_MODULE';

const modules = [
  /* ### Search ### */
  new Module.Builder(SEARCH_MODULE.SEARCH_GROUP_WRAPPER)
    .with(SEARCH_MODULE.CHILDREN.SEARCH_MODULE)
    .build(),
  /* ### Dashboard ### */
  new Module.Builder(DASHBOARD_MODULE.DASHBOARD_GROUP_WRAPPER)
    .with(DASHBOARD_MODULE.CHILDREN.DASHBOARD_MODULE)
    .build(),
  /* ### Current User ### */
  new Module.Builder(CURRENT_USER_MODULE.CURRENT_USER_GROUP_WRAPPER)
    .with(CURRENT_USER_MODULE.CHILDREN.USER_PROFILE_MODULE)
    .build(),
  /* ### Workingtime ### */
  new Module.Builder(WORKING_TIME_MODULE.WORKING_TIME_GROUP_WRAPPER)
    .with(WORKING_TIME_MODULE.CHILDREN.TIMETRACKING_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.ATTENDANCE_TYPES_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.OVERTIME_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.OVERTIME_TRIM_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTH_CLOSING_OVERVIEW_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTH_OF_EMPLOYEES_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.REOPEN_MONTH_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.MONTHLY_VERIFICATION_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.SICK_NOTES_MODULE)
    .with(WORKING_TIME_MODULE.CHILDREN.CALENDAR_MODULE)
    .build(),
  /* ### Project Management ### */
  new Module.Builder(PROJECT_MANAGEMENT_MODULE.PROJECT_MANAGMENT_GROUP_WRAPPER)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.PROJECTS_MODULE)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.PLANNING_REVIEW_MODULE)
    .with(PROJECT_MANAGEMENT_MODULE.CHILDREN.RESOURCE_PLANNING_MODULE)
    .build(),
  /* ### Invoices ### */
  new Module.Builder(INVOICE_MODULE.INVOICE_GROUP_WRAPPER)
    .with(INVOICE_MODULE.CHILDREN.TIMESHEET_BILLING_MODULE)
    .build(),
  /* ### Messages ### */
  new Module.Builder(NOTIFICATION_MODULE.NOTIFICATION_GROUP_WRAPPER)
    .with(NOTIFICATION_MODULE.CHILDREN.NOTIFICATION_MODULE)
    .build(),
  /* ### Report ### */
  new Module.Builder(REPORT_MODULE.REPORTS_GROUP_WRAPPER)
    .with(REPORT_MODULE.CHILDREN.ABSENT_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.EMPLOYEE_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.OCC_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.PROJECT_BUDGET_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.ANNIVERSARY_VIEW_MODULE)
    .with(REPORT_MODULE.CHILDREN.STOCK_VIEW_MODULE)
    .with(REPORT_MODULE.CHILDREN.SALES_STATISTICS_MODULE)
    .with(REPORT_MODULE.CHILDREN.OVERTIME_REPORT_MODULE)
    .with(REPORT_MODULE.CHILDREN.PROJECT_HOURS_MODULE)
    .build(),
  /* ### Official Holiday ### */
  new Module.Builder(OFFICIAL_HOLIDAYS_MODULE.OFFICIAL_HOLIDAYS_GROUP_WRAPPER)
    .with(OFFICIAL_HOLIDAYS_MODULE.CHILDREN.OFFICIAL_HOLIDAYS_MODULE)
    .with(OFFICIAL_HOLIDAYS_MODULE.CHILDREN.OFFICIAL_HOLIDAYS_CALENDARS_MODULE)
    .with(OFFICIAL_HOLIDAYS_MODULE.CHILDREN.STATES_MODULE)
    .build(),
  /* ### Employees ### */
  new Module.Builder(EMPLOYEES_MODULE.EMPLOYEES_GROUP_WRAPPER)
    .with(EMPLOYEES_MODULE.CHILDREN.EMPLOYEES_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.USERS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.ROLES_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.ACCESSGROUPS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.OCCUPATION_GROUPS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.GROUPS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.DEPARTMENTS_MODULE)
    .with(EMPLOYEES_MODULE.CHILDREN.DEPUTY_TYPE_MODULE)
    .build(),
  /* ### Contacts ### */
  new Module.Builder(CONTACT_MODULE.CONTACT_GROUP_WRAPPER)
    .with(CONTACT_MODULE.CHILDREN.CONTACTS_MODULE)
    .build(),
  /* ### Holiday ### */
  new Module.Builder(HOLIDAY_MODULE.HOLIDAY_GROUP_WRAPPER)
    .with(HOLIDAY_MODULE.CHILDREN.HOLIDAYS_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.HOLIDAY_ENTITLEMENT_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.DEPUTIES_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.APPROVALS_MODULE)
    .with(HOLIDAY_MODULE.CHILDREN.HOLIDAY_BAN_MODULE)
    .build(),
  /* ### Activity ### */
  new Module.Builder(ACTIVITY_MODULE.ACTIVITY_GROUP_WRAPPER)
    // .with(ACTIVITY_MODULE.CHILDREN.TRANSACTION_MODULE)
    .with(ACTIVITY_MODULE.CHILDREN.EMAIL_MODULE)
    .with(ACTIVITY_MODULE.CHILDREN.ACTIVITIES_MODULE)
    .build(),
  /* ### Warehouse ### */
  new Module.Builder(WAREHOUSE_MODULE.WAREHOUSE_GROUP_WRAPPER)
    .with(WAREHOUSE_MODULE.CHILDREN.STOCK_MODULE)
    .with(WAREHOUSE_MODULE.CHILDREN.STORAGE_MODULE)
    .with(WAREHOUSE_MODULE.CHILDREN.WAREHOUSE_TYPES_MODULE)
    .with(WAREHOUSE_MODULE.CHILDREN.INVENTORIES_MODULE)
    .with(WAREHOUSE_MODULE.CHILDREN.PROCUREMENTS_MODULE)
    .with(WAREHOUSE_MODULE.CHILDREN.STORAGE_ORDERS_MODULE)
    .with(WAREHOUSE_MODULE.CHILDREN.COMPANY_LOCATIONS_MODULE)
    .build(),
  /* ### Ordering ### */
  new Module.Builder(ORDERING_MODULE.ORDERING_GROUP_WRAPPER)
    .with(ORDERING_MODULE.CHILDREN.ORDERS_MODULE)
    .with(ORDERING_MODULE.CHILDREN.ORDER_SUGGESTIONS_MODULE)
    .build(),
  /* ### PROCESS_SUPPORT ### */
  new Module.Builder(PROCESS_SUPPORT_MODULE.PROCESS_SUPPORT_GROUP_WRAPPER)
    .with(PROCESS_SUPPORT_MODULE.CHILDREN.NOTICE_MODULE)
    .with(PROCESS_SUPPORT_MODULE.CHILDREN.MESSAGE_MODULE)
    .with(PROCESS_SUPPORT_MODULE.CHILDREN.NOTIFICATION_GROUPS_MODULE)
    .with(PROCESS_SUPPORT_MODULE.CHILDREN.TEXTBLOCKS_MODULE)
    .build(),
  /* ### System configuration ### */
  new Module.Builder(CONFIGURATION_MODULE.SYS_CONFIG_GROUP_WRAPPER)
    .with(CONFIGURATION_MODULE.CHILDREN.REGISTRY_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.CONFIG_FIXTURES_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.NOTIFICATION_CONFIGURATION_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.ATTRIBUTE_CATEGORIES_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.DOCUMENT_MODULE)
    .with(CONFIGURATION_MODULE.CHILDREN.ERROR_ANALYSIS_MODULE)
    .build()
]

export default generateModules(modules);
